import { atom } from "recoil";
import { OfficeBMOType } from "../types";


export const addStateOfficeBMO = atom({
  key: "addStateOfficeBMO",
  default: false,
});
export const editStateOfficeBMO = atom({
  key: "editStateOfficeBMO",
  default: false,
});
export const rowEditOfficeBMO = atom<OfficeBMOType | undefined>({
  key: "rowEditOfficeBMO",
  default: undefined,
});

export const selectedRowsStateOfficeBMO = atom<OfficeBMOType[]>({
  key: "selectedRowsStateOfficeBMO",
  default: [],
});

export const officeBMOFilterText = atom({
  key: "officeBMOFilterText",
  default: "",
});

export const savingOfficeBMO = atom({
  key: "savingOfficeBMO",
  default: false,
});
export const officeBMOFetching = atom({
  key: "officeBMOFetching",
  default: true,
});
export const officeBMOReFetching = atom({
  key: "officeBMOFetching",
  default: true,
});

